import { Component, Input } from '@angular/core'

/**
 * Membrete de Rendafin para cualquier documento que se imprima desde la plataforma.
 *
 * Es INVISIBLE en pantalla y solo aparece al imprimir (`@media print`), así que se puede
 * dejar puesto en cualquier pantalla imprimible sin afectar su diseño. La idea es que
 * todos los documentos que emita la plataforma salgan con el mismo membrete: pantalla
 * nueva imprimible ⇒ se le pone `<app-print-header>` y ya.
 *
 * ```html
 * <app-print-header [title]="doc.title" [subtitle]="doc.subtitle" [meta]="'v1.0 · 14 ago 2026'">
 * </app-print-header>
 * ```
 *
 * El encabezado y pie del navegador (fecha, título, URL) NO se pueden quitar por CSS: se
 * desactivan en el propio diálogo de impresión con «Más opciones › Encabezados y pies».
 */
@Component({
  selector: 'app-print-header',
  templateUrl: './print-header.component.html',
  styleUrls: ['./print-header.component.scss'],
})
export class PrintHeaderComponent {
  /** Título del documento. */
  @Input() title = ''

  /** Descripción de una línea bajo el título. */
  @Input() subtitle = ''

  /** Versión, fecha de actualización, folio… lo que identifique la emisión. */
  @Input() meta = ''

  /** Leyenda del pie. Se deja configurable por si un documento tiene otra clasificación. */
  @Input() footNote = 'Documento interno de Rendafin'

  readonly printedAt = new Date()
}
